import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';

import { onSetField } from './utils';

export default function* listenSetField() {
  yield takeEvery(actionTypes.SET_FIELD_VALUE, onSetField);
}
